<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const emit = defineEmits(['close'])
const { t } = useI18n()
</script>

<template>
  <div class="sidebar-panel is-generic">
    <div class="subpanel-header">
      <h3 class="no-mb">{{ t('sidebar-operation') }}</h3>
      <div class="panel-close" @click="emit('close')">
        <i aria-hidden="true" class="iconify" data-icon="feather:x"></i>
      </div>
    </div>
    <div class="inner" data-simplebar>
      <ul>
        <li>
          <RouterLink :to="{ name: 'operation-kv' }">
            <i class="lnir lnir-key-alt" aria-hidden="true"></i>
            {{ t('sidebar-operation-kv') }}
          </RouterLink>
        </li>
        <li v-has-nested-router-link class="has-children">
          <div class="collapse-wrap">
            <a class="parent-link">
              {{ t('sidebar-operation-push') }}
              <i
                aria-hidden="true"
                class="iconify"
                data-icon="feather:chevron-right"
              />
            </a>
          </div>
          <ul>
            <!--  新建推送  -->
            <li>
              <RouterLink :to="{ name: 'operation-push-create' }">
                <i class="fas fa-paper-plane" aria-hidden="true"></i>
                {{ t('sidebar-operation-push-new') }}
              </RouterLink>
            </li>
            <!--  推送列表  -->
            <li>
              <RouterLink :to="{ name: 'operation-push' }">
                <i
                  class="iconify"
                  data-icon="feather:grid"
                  aria-hidden="true"
                ></i>
                {{ t('sidebar-operation-push-list') }}
              </RouterLink>
            </li>
          </ul>
        </li>
        <!-- 爬虫 -->
        <li v-has-nested-router-link class="has-children">
          <div class="collapse-wrap">
            <a class="parent-link">
              {{ t('sidebar-operation-crawler') }}
              <i
                aria-hidden="true"
                class="iconify"
                data-icon="feather:chevron-right"
              />
            </a>
          </div>
          <ul>
            <li>
              <RouterLink
                :to="{ name: 'operation-crawler' }"
                class="is-submenu"
              >
                <i aria-hidden="true" class="lnil lnil-bug-alt"></i>
                <span>{{ t('sidebar-operation-crawler-list') }}</span>
              </RouterLink>
            </li>
            <li>
              <RouterLink
                :to="{ name: 'operation-crawler-playground' }"
                class="is-submenu"
              >
                <i class="lnil lnil-rocket" aria-hidden="true"></i>
                <span>{{ t('page-title-crawler-playground') }}</span>
              </RouterLink>
            </li>
            <li>
              <RouterLink
                :to="{ name: 'operation-crawler-batch' }"
                class="is-submenu"
              >
                <i class="lnil lnil-code" aria-hidden="true"></i>
                <span>{{ t('page-title-crawler-batch') }}</span>
              </RouterLink>
            </li>
          </ul>
        </li>
        <!-- 邮件管理 -->
        <li>
          <RouterLink
            :to="{ name: 'operation-mail-management' }"
            class="is-submenu"
          >
            <i
              class="iconify sidebar-svg"
              data-icon="feather:mail"
              aria-hidden="true"
            ></i>
            <span>{{ t('sidebar-operation-mail-management') }}</span>
          </RouterLink>
        </li>
        <li>
          <!-- omen研报分类管理 -->
          <RouterLink :to="{ name: 'operation-omen-category' }">
            <i
              aria-hidden="true"
              class="iconify sidebar-svg"
              data-icon="feather:cpu"
            ></i>
            {{ t('sidebar-operation-report-category-management') }}
          </RouterLink>
        </li>
        <!-- 导航配置 -->
        <li>
          <RouterLink :to="{ name: 'operation-navigator' }">
            <i
              aria-hidden="true"
              class="iconify sidebar-svg"
              data-icon="feather:cpu"
            ></i>
            {{ t('sidebar-operation-navigator-config') }}
          </RouterLink>
        </li>
        <li>
          <!-- web banner配置 -->
          <RouterLink :to="{ name: 'operation-banner' }">
            <i
              aria-hidden="true"
              class="iconify sidebar-svg"
              data-icon="feather:cpu"
            ></i>
            {{ t('sidebar-operation-web-banner-config') }}
          </RouterLink>
        </li>
        <li>
          <!-- 首页快速入口管理 -->
          <RouterLink :to="{ name: 'operation-entry' }">
            <i
              aria-hidden="true"
              class="iconify sidebar-svg"
              data-icon="feather:cpu"
            ></i>
            {{ t('sidebar-operation-entry-home-management') }}
          </RouterLink>
        </li>
        <!-- app开机页 -->
        <li>
          <RouterLink :to="{ name: 'operation-splash' }">
            <i
              class="iconify"
              data-icon="feather:edit-2"
              aria-hidden="true"
            ></i>
            {{ t('sidebar-operation-app-splash-screen') }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
@import '../../scss/abstracts/_variables.scss';
@import '../../scss/layout/_sidebar-panel.scss';
</style>
